import React, { Fragment, useContext, useEffect, useState } from "react";
import { Alert, Button, Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import { BasicContext } from "../../../App";
import { postMethod } from "../../../requests";
import ClassCard from "../../../components/classes/ClassCard";
import SelectStudentDropdown from "../../../components/dropdowns/SelectStudentDropdown";
import ChoosePass from "../../../components/passes/ChoosePass";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import GoBackBtn from "../../../components/buttons/GoBackBtn";
import PaymentForPassModal from "../../../components/modals/PaymentForPassModal";

const AddUserToClass = () => {
    const { t } = useTranslation();
    const { checkServerData, setAlerts, changeView, showView } = useContext(BasicContext);
    const [blockForm, setBlockForm] = useState(false);
    const [formChanged, setFormChanged] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [disableStudentDropdown, setDisableStudentDropdown] = useState(false);
    const [studentAssignment, setStudentAssignment] = useState(null);
    const [selectedPass, setSelectedPass] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedPassWithoutSigningIn, setSelectedPassWithoutSigningIn] = useState(null);
    const [showPaymentForPassModal, setShowPaymentForPassModal] = useState(null);
    const [reloadActivePasses, setReloadActivePasses] = useState(false);
    const classData = showView.params.c;

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];
        if (!selectedStudent) {
            $("#selectStudentDropdown").addClass("is-invalid");
            errors.push(t("error.noClassName"));
        }
        //(selectedPass);
        //console.log(selectedPassWithoutSigningIn);

        if (!selectedPass && selectedPassWithoutSigningIn) {
            if (!selectedPassWithoutSigningIn.pass) {
                errors.push(t("error.noPassSelected"));
            }
            if (!selectedPassWithoutSigningIn.paymentMethod) {
                errors.push(t("error.noCheckedPaymentMethod"));
            }
        } else if (!selectedPass && !selectedPassWithoutSigningIn) {
            errors.push(t("error.noPassSelected"));
        }

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            setAlerts([{ variant: "info", message: t("info.addingStudentToClass") }]);
            setBlockForm(true);
            addStudentToClass();
        }
    };

    const addStudentToClass = async () => {
        //console.log(selectedPass, selectedPassWithoutSigningIn);
        const res = await postMethod("/add-student-to-class", {
            userID: selectedStudent,
            class: classData,
            upID: selectedPass,
            pass: selectedPassWithoutSigningIn ? selectedPassWithoutSigningIn.pass : null,
            paymentMethod: selectedPassWithoutSigningIn ? selectedPassWithoutSigningIn.paymentMethod : null,
        });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "studentAdded" }]);
            changeView({ nav: "schedule", sub: "checkAttendance", params: { class: classData, changedData: true } });
        } else setBlockForm(false);
    };

    const checkStudentAssignment = async () => {
        const res = await postMethod("/check-student-assignment-to-class", { userID: selectedStudent, classID: classData.class_id });
        if (checkServerData(res)) {
            if (res.data.code !== "notAssigned") {
                setStudentAssignment(res.data.code);
                setBlockForm(true);
            } else if (selectedStudent === classData.instructor_id) setBlockForm(true);
            else {
                setStudentAssignment(null);
                setBlockForm(false);
            }
        }
        setDisableStudentDropdown(false);
        setLoading(false);
    };

    useEffect(() => {
        if (selectedStudent) {
            setDisableStudentDropdown(true);
            setStudentAssignment(null);
            setLoading(true);
            setTimeout(() => {
                checkStudentAssignment();
            }, 200);
        }
        // eslint-disable-next-line
    }, [selectedStudent]);

    return (
        <Fragment>
            <GoBackBtn />
            <Form onSubmit={checkValidation} autoComplete="off">
                <Container fluid="lg">
                    <Row>
                        <Col xs={12} className="px-4 mb-4 px-lg-2">
                            <h1 className="h5 d-inline-block m-0 pt-2">{t("schedule.addToClass")}</h1>
                        </Col>
                        <Col xs={12} className="px-4 mb-4 px-lg-2">
                            <Row>
                                <Col xs={12} lg={6} className="mb-3">
                                    <ClassCard c={classData} />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} lg={6} className="mb-3">
                                    <SelectStudentDropdown
                                        id="selectStudentDropdown"
                                        value={selectedStudent}
                                        onChange={(v) => {
                                            setSelectedStudent(v);
                                            setFormChanged(true);
                                            $("#selectStudentDropdown").removeClass("is-invalid");
                                        }}
                                        disabled={disableStudentDropdown}
                                    />
                                </Col>
                                {selectedStudent &&
                                    (loading ? (
                                        <p className="fs-5 text-center my-3">
                                            {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                                        </p>
                                    ) : (
                                        <Fragment>
                                            {studentAssignment ? (
                                                <Col xs={12} className="mb-3">
                                                    <Alert variant="info" className="alert-small">
                                                        {t(`users.assignment.${studentAssignment}`)}
                                                    </Alert>
                                                </Col>
                                            ) : selectedStudent === classData.instructor_id ? (
                                                <Col xs={12} className="mb-3">
                                                    <Alert variant="warning" className="alert-small">
                                                        {t(`users.assignment.INSTR`)}
                                                    </Alert>
                                                </Col>
                                            ) : (
                                                <Col xs={12}>
                                                    <ChoosePass
                                                        selectedPass={selectedPass}
                                                        setSelectedPass={setSelectedPass}
                                                        setFormChanged={setFormChanged}
                                                        blockForm={blockForm}
                                                        classID={classData.class_id}
                                                        userID={selectedStudent}
                                                        modalView
                                                        addingToClassByInstr
                                                        selectedPassWithoutSigningIn={selectedPassWithoutSigningIn}
                                                        setSelectedPassWithoutSigningIn={setSelectedPassWithoutSigningIn}
                                                        onShowPaymentForPassModal={setShowPaymentForPassModal}
                                                        reloadActivePasses={reloadActivePasses}
                                                        setReloadActivePasses={setReloadActivePasses}
                                                    />
                                                </Col>
                                            )}
                                        </Fragment>
                                    ))}
                            </Row>
                        </Col>
                    </Row>
                    <Row className="sticky-bottom bg-light-primary" style={{ zIndex: 2 }}>
                        <Col xs={8}>
                            <Button variant="primary" className="px-4 mt-4 mb-4" type="submit" disabled={blockForm || !formChanged}>
                                {t("saveChanges")}
                            </Button>
                        </Col>
                        <Col xs={4} className="text-end">
                            <Button variant="outline-secondary" className="px-4 mt-4 mb-4" onClick={() => changeView({ nav: "schedule", sub: "main", params: { moduleName: "ADMIN_APP" } })}>
                                {t("cancel")}
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Form>

            {showPaymentForPassModal && (
                <PaymentForPassModal
                    pass={showPaymentForPassModal}
                    onClose={() => setShowPaymentForPassModal(false)}
                    onProceed={() => {
                        setShowPaymentForPassModal(false);
                        setReloadActivePasses(true);
                    }}
                    signUpForClass
                    userID={selectedStudent}
                />
            )}
        </Fragment>
    );
};

export default AddUserToClass;
